<template>
  <div class="input-treatments">
    <input-cart
      v-model="innerValue"
      :categories="treatmentCategories"
      :cart-title="cartTitle"
      :add-label="addLabel"
      :add-inside-label="addInsideLabel"
      :no-label="noLabel"
      :show-no-button="false"
    />
  </div>
</template>

<script>

import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import { compareArrays } from '@/utils/arrayUtil';
import InputComponent from '../InputComponent';
import InputCart from '../InputCart/InputCart';

export default {
  name: 'InputTreatment',
  components: { InputCart },
  extends: InputComponent,
  props: {
    modelValue: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      innerValue: null,
    };
  },
  computed: {
    ...mapState(useSurveyStore, ['language', 'treatmentCategories']),
    cartTitle() {
      return this.$t('treatment.title');
    },
    addLabel() {
      return this.$t('treatment.buttonAdd');
    },
    addInsideLabel() {
      return this.$t('treatment.buttonAddInside');
    },
    noLabel() {
      return this.$t('treatment.buttonNo');
    },
    inputBarHeight() {
      let currentChoiceHeightPercent = 0;

      if (this.currentChoiceIndex >= 0 && this.calculatedChoices.length) {
        currentChoiceHeightPercent = ((this.currentChoiceIndex + 1) / this.calculatedChoices.length) * 100;
      }

      return `${currentChoiceHeightPercent}%`;
    },
  },
  watch: {
    modelValue: {
      handler() {
        const newInnerValue = compareArrays(this.modelValue, this.innerValue, true);

        // console.log('newValue', newInnerValue, this.modelValue, this.innerValue);

        if (newInnerValue === true) {
          // It's already the same values
          return;
        }

        this.innerValue = newInnerValue;
      },
      deep: true,
    },
    innerValue: {
      handler() {
        const newValue = compareArrays(this.innerValue, this.modelValue, true);

        if (newValue === true) {
          // It's already the same values
          return;
        }

        this.$emit('update:modelValue', newValue);
      },
      deep: true,
    },
  },
  beforeMount() {
    if (!this.innerValue) {
      this.innerValue = this.modelValue || [];
    }
  },
  methods: {
    getName(item) {
      return item.name;
    },
  },
};

</script>

<style lang="scss" scoped>
</style>
